module.exports = __webpack_public_path__ + "static/media/My-Physio-My-Health-logox2.aaac54ec.png";